import {
  AudioLines,
  Calculator,
  Captions,
  FileCode2,
  FileText,
  FileVideo2,
  Gauge,
  ListOrdered,
  MessagesSquare,
  MonitorPlay,
  Music4,
  PenLine,
  Presentation,
  Quote,
  Radio,
  ScrollText,
  Video,
  Volume2,
  WholeWord,
  Youtube,
  type LucideIcon,
} from 'lucide-react';

import type { FreeToolIconName } from '@/lib/free-tools/registry';

/**
 * Resolves the registry's icon NAME to a component.
 *
 * The registry stores names rather than components so it stays React-free (it is
 * imported by the sitemap and the content-pipeline worker) and so a definition can
 * cross a server/client boundary as props.
 *
 * `Sparkles` is not in `FreeToolIconName` and must not be added: it reads as AI slop.
 */
const ICONS: Record<FreeToolIconName, LucideIcon> = {
  AudioLines,
  Calculator,
  Captions,
  FileCode2,
  FileText,
  FileVideo2,
  Gauge,
  ListOrdered,
  MessagesSquare,
  MonitorPlay,
  Music4,
  PenLine,
  Presentation,
  Quote,
  Radio,
  ScrollText,
  Video,
  Volume2,
  WholeWord,
  Youtube,
};

export function FreeToolIcon({ name, className }: { name: FreeToolIconName; className?: string }) {
  const Icon = ICONS[name];

  return <Icon className={className} aria-hidden />;
}
